import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Layout,
  ClientService,
  Loading,
  Error,
} from 'quanta-flows/modules/layout';//'../../../../lib/layout';
import {
  Card,
  SummaryLayout,
  useResponsiveParams,
  Text,
} from 'quanta-ui';
import QuoteSummaryPanel from './quote-summary-panel';
import QuoteWizardPanel from './quote-wizard-panel';
//import { initMotorQuoteState } from 'quanta-flows/modules/quote/motor/state'; //./_graphql/state';
// import  {initMotorQuoteState  }from  './_graphql/state';
import { initMotorQuoteState } from 'quanta-flows/modules/quote/motor/state';  
 import { initBuyMotorPolicyVar } from 'quanta-flows/modules/proposal/motor/state';
// import  initBuyMotorPolicyVar  from './_graphql/state';
import { PRODUCT_TYPE_LIST } from './queries';
import { useQuery } from '@apollo/client';
import CopyQuote from './quote-summary-panel/copy-quote';

export default function CaptureMiscDDetails({
  productName,
  productCode,
  lobCode,
  quoteNumber,
  lobName,
  modify,
  breadcrumbNav,
}) {
  let nav = ['Quote', 'Get Quote'];
  const [moveToPlans, setMoveToPlans] = useState(false);
  const product_name = productName
    ? productName
    : useParams().product_name;
  const product_code = productCode
    ? productCode
    : useParams().product_code;
  const lob_code = lobCode ? lobCode : useParams().lob_code;
  const quote_number = quoteNumber ? quoteNumber : undefined;
  const lob_name = lobName ? lobName : useParams().lob_name;
  const coversFormRef = useRef();
  const [productCode1,setProductCode]=useState(product_code?product_code:'3128');
  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const screenType = useResponsiveParams({
    for_desktop: 'desktop',
    for_mobile: 'mobile',
    for_iPad: 'ipad',
  });
  useEffect(() => {
    if (quote_number === undefined || quote_number === null) {
      const res = initMotorQuoteState(true);
      if (res) {
        setMoveToPlans(true);
      }
      initBuyMotorPolicyVar();
    }
 
  }, [quote_number]);

  const { loading, error, data } = useQuery(PRODUCT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error error={error} />;
  }
  const { lobProductList } = data;
  const category=(lobProductList
    ?.find(
      (lob) =>
        lob?.lob_code?.toString()?.toLowerCase() ===
        lob_code?.toString()?.toLowerCase(),
    )
    ?.products?.find(
      (product) =>
        product?.product_code?.toString()?.toLowerCase() ===
          product_code?.toString()?.toLowerCase() &&
        product?.product_name?.toString()?.toLowerCase() ===
          product_name?.toString()?.toLowerCase()
    )?.product_category);
    const display_name=(lobProductList
      ?.find(
        (lob) =>
          lob?.lob_code?.toString()?.toLowerCase() ===
          lob_code?.toString()?.toLowerCase(),
      )
      ?.products?.find(
        (product) =>
          product?.product_code?.toString()?.toLowerCase() ===
            product_code?.toString()?.toLowerCase() 
      )?.display_name);
  return (
    <Layout
      nav={breadcrumbNav ? breadcrumbNav : nav}
      service_type={ClientService}
      title={`Your ${display_name?display_name:product_name} Quote`}
    >
      {lobProductList
        ?.find(
          (lob) =>
            lob?.lob_code?.toString()?.toLowerCase() ===
            lob_code?.toString()?.toLowerCase(),
        )
        ?.products?.find(
          (product) =>
            product?.product_code?.toString()?.toLowerCase() ===
              product_code?.toString()?.toLowerCase()
              //  && product?.product_name?.toString()?.toLowerCase() ===
              // product_name?.toString()?.toLowerCase()
              ,
        ) ? (
        <>
          <SummaryLayout
            summary={
              <div
                className={`${
                  ['mobile', 'ipad']?.includes(
                    screenType?.toString()?.toLowerCase(),
                  )
                    ? ''
                    : 'sticky'
                } top-0`}
              >
                {screenType?.toString()?.toLowerCase() ===
                  'desktop' && (
                <div className="flex flex-col justify-start h-auto">
                  <CopyQuote
                    productCode={productCode1}
                    productName={product_name}
                    lobCode={lob_code}
                    quoteNumber={quote_number}
                    setMoveToPlans={setMoveToPlans}
                  />
                </div>
                )}
                <div className="flex flex-col justify-start h-auto">
              <QuoteSummaryPanel
                forwardedCoversFormRef={coversFormRef}
                productCode={productCode1}
                lobCode={lob_code}
                lobName={lob_name}
                    category={category}
              />
                </div>
              </div>
            }
          >
            <Card className="min-h-screen">
              <QuoteWizardPanel
                forwardedCoversFormRef={coversFormRef}
                lobCode={lob_code}
                productName={product_name}
                productCode={product_code}
                quoteNumber={quote_number}
                lobName={lob_name}
                productCode1={productCode1}
                setProductCode={setProductCode}
                moveToPlans={moveToPlans}
                setMoveToPlans={setMoveToPlans}
                modify={modify}
              />
            </Card>
          </SummaryLayout>
          {screenType?.toString()?.toLowerCase() !== 'desktop' && (
            <CopyQuote
              productCode={productCode1}
              productName={product_name}
              lobCode={lob_code}
              quoteNumber={quote_number}
              setMoveToPlans={setMoveToPlans}
            />
          )}
          <div className="bg-neutral sticky bottom-0 p-3 -mx-4 mt-2 -mb-4 xl:hidden">
            <QuoteSummaryPanel
              forwardedCoversFormRef={coversFormRef}
              productCode={productCode1}
              productName={product_name}
              lobCode={lob_code}
              lobName={lob_name}
              quoteNumber={quote_number}
              category={category}
            />
          </div>
        </>
      ) : (
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Given Lob/Product Information is not Available or Invalid
          </Text>
        </Card>
      )}
    </Layout>
  );
}
